/**
 * Vuex module for contact tags
 */
import debug from 'debug'

const dbg = debug('store:contacts:TagForm:')

const actions = {
  open ({ commit }, { tag, isPersonal, isUpdate }) {
    dbg('Open tag form dialog')
    if (process.env.NODE_ENV === 'test') {
      return true
    }
    commit('OPEN_DIALOG', { tag, isPersonal, isUpdate })
  },
  close ({ commit }) {
    dbg('Close tag form dialog')
    if (process.env.NODE_ENV === 'test') {
      return true
    }
    commit('CLOSE_DIALOG')
  },
  setTag ({ commit }, tag) {
    commit('SET_TAG', tag)
  }
}

const mutations = {
  CLOSE_DIALOG (state) {
    state.tag = null
    state.isPersonal = false
    state.isUpdate = false
    state.dialog = false
  },

  OPEN_DIALOG (state, { tag, isPersonal, isUpdate }) {
    state.dialog = true
    state.tag = tag
    state.isPersonal = isPersonal
    state.isUpdate = isUpdate
  },

  SET_TAG (state, tag) {
    state.tag = tag
  }
}

const state = {
  dialog: false,
  tag: null,
  isPersonal: false,
  isUpdate: false
}

const getters = {
  dialog: state => state.dialog,
  tag: state => state.tag,
  isPersonal: state => state.isPersonal,
  isUpdate: state => state.isUpdate
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
